import { api } from "../core/api.js";
import { h } from "../core/dom.js";
import { t } from "../core/i18n.js";
import { loadInto, skeletonGrid } from "../core/states.js";
import type { Page, Title } from "../models.js";

export async function feedView(_params: Record<string, string>, root: HTMLElement): Promise<void> {
  await loadInto<Page<Title>>({
    root,
    loading: () => h("section", {}, h("h2", {}, t("feed.trending")), skeletonGrid()),
    load: () => api.get<Page<Title>>("/v1/titles?limit=24"),
    isEmpty: (page) => page.items.length === 0,
    empty: t("feed.empty"),
    render: (page) => {
      const grid = h(
        "div",
        { class: "grid" },
        ...page.items.map((item) =>
          h(
            "a",
            {
              class: "card",
              href: `/t/${item.id}`,
              "data-link": true,
              "aria-label": item.title,
            },
            h("div", { class: "poster", role: "img", "aria-hidden": "true" }),
            h(
              "div",
              { class: "meta" },
              h("p", { class: "title" }, item.title),
              h(
                "div",
                { class: "sub" },
                h("span", { class: "badge ai" }, t("compliance.aiBadge")),
                " ",
                t(item.kind === "drama" ? "kind.drama" : "kind.movie"),
              ),
            ),
          ),
        ),
      );
      return h("section", {}, h("h2", {}, t("feed.trending")), grid);
    },
  });
}
